import {api} from '@/http'

// 付款单位列表
const getPayerList = (data, callback, back) => {
  api('/api/Payer/List', 'post', data, callback, back)
}

// 付款单位添加
const addPayer = (data, callback, back) => {
  api('/api/Payer/Insert', 'post', data, callback, back)
}

// 付款单位删除
const delPayer = (id, callback, back) => {
  api('/api/Payer/Delete', 'post', {Id: id}, callback, back)
}

// 付款单位详情
const detailPayer = (id, callback, back) => {
  api('/api/Payer/Detail', 'post', {Id: id}, callback, back)
}

// 待收款项目列表
const getPayableList = (data, callback, back) => {
  api('/api/Finance/List', 'post', data, callback, back)
}

// 待收款项目-确认收款
const payableSure = (id, callback, back) => {
  api('/api/Finance/Examine', 'post', {Id: id}, callback, back)
}

// 待收款项目-详情
const payableDetail = (id, callback, back) => {
  api('/api/Finance/RecordDetail', 'post', {Id: id}, callback, back)
}

// 已收款项目列表
const getPaymentList = (data, callback, back) => {
  api('/api/Finance/CompleteList', 'post', data, callback, back)
}

// 已收款项目-导出
const exportPayment = (data, callback, back) => {
  api('/api/Finance/Export', 'post', data, callback, back)
}

// 公章列表
const getCachetList = (data, callback, back) => {
  api('/api/GongZhang/List', 'post', data, callback, back)
}

// 公章-导出
const exportCachet = (data, callback, back) => {
  api('/api/GongZhang/Export', 'post', data, callback, back)
}

// 公章-通过
const passCachet = (id, callback, back) => {
  api('/api/GongZhang/Examine', 'post', {Id: id}, callback, back)
}

export default {
  getPayerList,
  addPayer,
  delPayer,
  detailPayer,
  getPayableList,
  payableSure,
  payableDetail,
  getPaymentList,
  exportPayment,
  getCachetList,
  exportCachet,
  passCachet
}



// WEBPACK FOOTER //
// ./src/api/finance/index.js